const HeadingTitle = ({text="",style=""}) => {
  return <h2 className={style}>{text || ""}</h2>
}

export default HeadingTitle
